import React from "react";
import { Typography } from "@mui/material";
import MainContainer from "../grid-component/MainContainer";
import ContainerContent from "../grid-component/ContainerContent";
import Header from "src/Component/content-component/Header";
import ImageContant from "../grid-component/ImageContant";

const ImmersionTabContant = ({ title, content, image }) => {
  return (
    <MainContainer
      color={"#EFFDFF"}
      com1={
        <ContainerContent
          Header={
            <Header
              content={title}
              fontSize={{
                xs: "24px",
                sm: "26px",
                md: "40px",
                lg: "40px",
              }}
              sx={{ textAlign: "left" }}
            />
          }
          Content={
            <Typography
              sx={{
                fontSize: "20px",
                fontFamily: "Poppins",
                margin: "16px 0",
                color: "#525560",
                fontWeight: 500,
                textAlign: "left",
                padding: "0 20px",
              }}
            >
              {content}
            </Typography>
          }
        />
      }
      com2={<ImageContant img={image} />}
    />
  );
};

export default ImmersionTabContant;
